export default (title: string, shareUrl?: string) => ({
  copied: false,

  async share() {
    const url = shareUrl
      ? new URL(shareUrl, window.location.href).href
      : window.location.href

    if (navigator.share) {
      try {
        await navigator.share({ title, url })
      }
      catch (error) {
        if ((error as DOMException).name !== 'AbortError') {
          console.error(error)
        }
      }

      return
    }

    await navigator.clipboard.writeText(url)

    this.copied = true

    setTimeout(() => this.copied = false, 2000)
  },
})
